import API from '../../../helpers/api';

import { loadLang } from '../../data/actions/Data';
import CLIENT from '../actionTypes';

import { AppDispatch, GetState } from '../../../types/app';
import { ClientLoginData } from '../types';

export const loadLoginData = () => async (dispatch: AppDispatch) => {
  dispatch({ type: CLIENT.LOAD.REQUESTING });

  try {
    const data = await API.loadLoginData<ClientLoginData>();

    dispatch({
      type: CLIENT.LOAD.SUCCESS,
      data,
    });

    return data;
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);

    dispatch({ type: CLIENT.LOAD.FAILURE, err: message });
    throw err;
  }
};

export const loadLoginDataIfNeeded =
  () => async (dispatch: AppDispatch, getState: GetState) => {
    const { Client } = getState();

    if (
      Client.data === undefined &&
      Client.loadReadyStatus === CLIENT.LOAD.INVALID &&
      getState().Data.config?.profileHost
    ) {
      try {
        await dispatch(loadLoginData());
      } catch (err) {
        console.error('Failed to load login data:', err);
      }
    }
  };

export const setLang = (lang: string) => async (dispatch: AppDispatch) => {
  dispatch({
    type: CLIENT.SET_LANG,
    data: lang,
  });
};

export const changeLang =
  (lang: string) => async (dispatch: AppDispatch, getState: GetState) => {
    const { isLoggedIn } = getState().Client;

    if (isLoggedIn) {
      await API.callGraphQL<{ result: boolean }>(
        `
          mutation ($lang: Lang) {
            result: clientPersonalInfoSave(Lang: $lang)
          }
        `,
        { lang }
      );
    }

    const loaded = await dispatch(loadLang(lang));

    if (loaded) {
      await dispatch(setLang(lang));
    }
  };

export const logout =
  () => async (_dispatch: AppDispatch, getState: GetState) => {
    const {
      intl: { locale: lang },
    } = getState();

    try {
      await API.callGraphQL<{ url: string }>(
        `
      mutation($lang: Lang!) {
        url: clientLogout(Lang: $lang)
      }
    `,
        { lang }
      );

      window.location.href = '/';
    } catch (err) {
      console.error(err);
    }
  };
